import { Plus } from "@phosphor-icons/react";

export const LoanForm = ({ emps, form, setForm, onSubmit }) => (
  <form onSubmit={onSubmit} className="flex flex-wrap items-end gap-3">
    <div className="flex-1 min-w-[180px]">
      <label className="text-xs font-semibold text-stone-500">Employee</label>
      <select required value={form.user_id} onChange={(e) => setForm({ ...form, user_id: e.target.value })} data-testid="loan-employee-select"
        className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="">Select…</option>
        {emps.map((e) => <option key={e.id} value={e.id}>{`${e.name} (${e.employee_code})`}</option>)}
      </select>
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Amount (₹)</label>
      <input type="number" min="1" step="0.01" required value={form.principal} onChange={(e) => setForm({ ...form, principal: e.target.value })} data-testid="loan-principal-input"
        className="mt-1 block w-28 min-h-[44px] px-3 rounded-lg border border-stone-300 text-right" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Per month (₹)</label>
      <input type="number" min="1" step="0.01" required value={form.monthly_installment} onChange={(e) => setForm({ ...form, monthly_installment: e.target.value })} data-testid="loan-installment-input"
        className="mt-1 block w-28 min-h-[44px] px-3 rounded-lg border border-stone-300 text-right" />
    </div>
    <div>
      <label className="text-xs font-semibold text-stone-500">Recover from</label>
      <input type="month" required value={form.start_month} onChange={(e) => setForm({ ...form, start_month: e.target.value })} data-testid="loan-start-month-input"
        className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
    </div>
    <div className="flex-1 min-w-[140px]">
      <label className="text-xs font-semibold text-stone-500">Remarks</label>
      <input placeholder="Festival advance" value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} data-testid="loan-remarks-input"
        className="mt-1 block w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
    </div>
    <button type="submit" data-testid="add-loan-button"
      className="tap-scale flex items-center gap-1 px-5 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200"><Plus size={16} weight="bold" /> Add</button>
  </form>
);
